import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generatePivotsRow} from '#core/application/modules/tiles/pivot/index.js';
import {generateEmptyContentMessage} from '#core/application/modules/tiles/empty-content-message/index.js';
import {PRICE_BOOST_ICON_SRC} from '#core/application/modules/tiles/price-boost-label/index.js';

import nflTeamsMap from './nfl-teams.json';

export function sportsContentFactory(PALETTE) {
    return {
        // for racing pages
        SportTabSelector: {
            tabs: merge(generatePivotsRow(PALETTE.SPORT_TABS_PIVOT), {
                itemLabel: {
                    style: {
                        padding: '1px 0',
                    },
                },
                style: {
                    container: {
                        margin: '0px 0px 8px',
                        boxShadow: PALETTE.SPORT_TABS_CONTAINER_SHADOW,
                    },
                },
                itemIcon: {
                    style: {
                        transition: {
                            overflow: 'visible', // Fix: Prevents SVG icons from being cut off at 90% browser zoom due to fractional pixel rendering
                        },
                    },
                },
            }),
        },
        InPlayPage: {
            pageTitle: {
                icon: {
                    buttonIcon: {
                        src: 'in-play-filled',
                    },
                },
            },
        },
        SportCouponPageView: {
            pageTitle: {
                icon: {
                    buttonIcon: {
                        src: 'arrow-left',
                    },
                },
            },
        },
        PriceBoostPageView: {
            pageTitle: {
                icon: {
                    buttonIcon: {
                        src: PRICE_BOOST_ICON_SRC,
                    },
                },
            },
        },
        ScoreCount: {
            goalAnimationDuration: 2000,
            animation: {
                animationDuration: '.6s',
            },
            style: {
                goalContainer: {
                    ...resolveBackground(PALETTE.GOAL_LABEL_BG),
                    transition: '.4s',
                    padding: '1.3px 9px',
                    minWidth: 'initial',
                    width: 'initial',
                    ...PALETTE.GOAL_LABEL_TEXT,
                },
            },
        },
        RedCard: {
            animation: {
                animationDuration: '.6s',
            },
            container: {
                createStackingContext: true,
            },
            style: {
                bannerContainer: {
                    ...resolveBackground(PALETTE.RED_CARD_BG),
                    top: -1, // to hide red card under this container
                    ...PALETTE.RED_CARD_TEXT,
                },
                card: {
                    ...resolveBackground(PALETTE.RED_CARD_BG),
                },
                text: {
                    ...PALETTE.RED_CARD_AMOUNT_TEXT,
                },
            },
        },
        EmptyContent: generateEmptyContentMessage(PALETTE.EVENT_PAGE_NO_CONTENT), // for all event pages
        ParticipantIconsInline: {
            separator: {
                container: {
                    padding: 0,
                },
            },
        },
        CompetitorIcons: {
            default: 'generic/team-icon-default.svg',
            ...(ALLOW_CUSTOM_TEAM_ICONS_USAGE
                ? Object.keys(nflTeamsMap).reduce(
                      (reducer, teamId) => ({
                          ...reducer,
                          [teamId]: `teamicons/nfl/${nflTeamsMap[teamId]}.svg`,
                      }),
                      {}
                  )
                : {}),
        },
    };
}
